// components/ThemeSwitcher/ThemeSwitcher.jsx
import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4'; // moon
import Brightness7Icon from '@mui/icons-material/Brightness7'; // sun

const ThemeSwitcher = ({ mode, toggleMode }) => {
  const isDark = mode === 'dark';

  return (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
      <IconButton
        color="inherit"
        onClick={toggleMode}
        sx={{
          position: 'absolute',
          right: 64, // a bit left of language switcher
          top: 16,
        }}
      >
        {isDark ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeSwitcher;
